import React from "react";
import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    label: "Ascolto",
    body: "Incontro in azienda, analisi delle esigenze reali. Ascoltiamo prima di parlare: capiamo il tuo business, i tuoi obiettivi e ciò che ti tiene sveglio la notte.",
    detail: "Sopralluogo · Intervista dirigenza · Mappa priorità",
  },
  {
    n: "02",
    label: "Analisi",
    body: "Esaminiamo numeri, processi e struttura. Un'analisi rigorosa che trasforma i dati in intuizioni concrete, e le intuizioni in leve di crescita.",
    detail: "Bilanci · KPI · Processi · Struttura societaria",
  },
  {
    n: "03",
    label: "Piano d'Azione",
    body: "Consegniamo un piano scritto concreto con priorità chiare. Non uno slide deck da tenere nel cassetto: un documento operativo, misurabile, attuabile.",
    detail: "Priorità · Timing · Metriche · Responsabilità",
  },
];

export default function Metodo() {
  return (
    <section
      id="metodo"
      data-testid="section-metodo"
      className="relative py-32 md:py-40 lg:py-48 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute top-16 -left-4 md:left-10 font-display italic text-[14rem] md:text-[22rem] leading-none text-gold/[0.06] select-none pointer-events-none"
      >
        03
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-3xl mb-20 md:mb-28">
          <Reveal>
            <div className="flex items-center gap-4 mb-8">
              <span className="w-10 h-px bg-gold" />
              <span
                className="text-[0.7rem] uppercase text-gold font-sans-crisp font-semibold"
                style={{ letterSpacing: "0.3em" }}
              >
                Capitolo 03 · Il Metodo
              </span>
            </div>
          </Reveal>

          <Reveal delay={0.05}>
            <h2
              data-testid="metodo-title"
              className="font-display font-medium tracking-tight leading-[1.02] text-4xl md:text-5xl lg:text-6xl text-ink"
            >
              Come <span className="italic-serif text-gold">lavoriamo</span>.
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="mt-8 text-lg text-ink/70 leading-relaxed max-w-2xl font-sans-crisp">
              Tre tappe. Un solo obiettivo: trasformare la complessità in azione.
              Nessuna consulenza vaga, nessuna slide-monster. Solo lavoro sul terreno.
            </p>
          </Reveal>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* connecting vertical gold line (mobile) / horizontal (desktop hidden — we use dots) */}
          <div className="absolute left-6 top-0 bottom-0 w-px bg-gold/20 lg:hidden" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-6">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 }}
                className="relative lg:pr-8"
                data-testid={`metodo-step-${s.n}`}
              >
                {/* Big numeral */}
                <div className="relative mb-8 flex items-center gap-6 pl-16 lg:pl-0">
                  <span className="absolute -left-2 lg:relative lg:left-0 w-14 h-14 rounded-full border border-gold flex items-center justify-center bg-navy-dark shrink-0">
                    <span className="text-gold font-display italic text-lg">{s.n}</span>
                  </span>
                  <span className="hidden lg:block flex-1 h-px bg-gold/25" />
                </div>

                <div className="pl-16 lg:pl-0">
                  <h3 className="font-display text-4xl md:text-5xl text-ink leading-none mb-6">
                    {s.label}
                  </h3>
                  <p className="text-ink/75 leading-relaxed text-base md:text-lg mb-6 font-sans-crisp">
                    {s.body}
                  </p>
                  <p
                    className="text-[0.7rem] uppercase text-gold/80 font-sans-crisp font-medium"
                    style={{ letterSpacing: "0.24em" }}
                  >
                    {s.detail}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
